import sortBy from "lodash/sortBy";
import isDesktop from 'lib/isDesktop';

/*

This functionality is highly coupled with the UI,
of which the markup comes from the content system.
Trailhead-web has no control over the content,
which is why we have to use some jqueryness.

This could definitely be improved by updating selectors
to be more robust and some further decoupling by passing
DOM as args

*/

// its ugly if anchors go to the exact
// top of element, so we use an offset (global nav height + 1rem)
const SCROLL_OFFSET = 212;

export function smoothTopicNav() {
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  $(".topic-list-nav a").on("click", (e) => {
    if (!isIE11) {
      e.preventDefault();
    }

    const link = $(e.target).closest("a")[0];
    const pos = $(link.getAttribute("href")).offset().top - SCROLL_OFFSET;

    window.scroll({
      top: pos,
      left: 0,
      behavior: "smooth"
    });
  });
}

export function stickyBreadcrumb() {
  const $breadcrumbWrapper = $(".th-sticky-breadcrumb");
  if ($breadcrumbWrapper.length === 0) {
    return;
  }

  const breadcrumb = $breadcrumbWrapper.children()[0];
  const $shim = $('<div class="th-sticky-breadcrumb__shim" />');

  $(breadcrumb).css({
    position: "fixed",
    width: "100%",
    top: document.getElementById("global-nav-container").offsetHeight
  });

  $shim.css({
    height: breadcrumb.offsetHeight,
    width: "100%"
  });

  $($shim).insertAfter($breadcrumbWrapper);

  const setPosition = () => {
    let offset = document.getElementById("contextnav").offsetTop + document.getElementById("contextnav").offsetHeight;
    $(breadcrumb).css({
      top: offset
    });
  };

  return {
    onScroll: setPosition
  };
}

export function stickyTopicNav() {
  const $sidebar = $("#unit-sidebar");

  const setSidebarPosition = (position) => {
    $sidebar.css({
      position: "sticky",
      top: `${155 + document.getElementById("contextnav").offsetTop}px`
    });
  };

  return {
    onScroll: setSidebarPosition
  };
}

export function scrollSpyTopicNav() {
  let $navAnchors = $(".topic-list-nav a");
  if ($navAnchors.length === 0) {
    return;
  }
  // clean topic nav, because sometimes there are emtpy items
  // ex: /modules/apex_integration_services/units/apex_integration_callouts
  $navAnchors.filter((i, a) => a.innerHTML.trim() === "").remove();
  // rebuild list
  $navAnchors = $(".topic-list-nav a");

  const createAnchorMap = () => {
    const $anchorHrefs = $navAnchors.map((i, a) => a.getAttribute("href")).toArray();
    const $bodyAnchors = $($anchorHrefs.join(","));

    const anchorMap = $bodyAnchors.map((i, a) => ({
      selector: `#${a.getAttribute("id")}`,
      offsetTop: $(a).offset().top - SCROLL_OFFSET - 5
    }));

    const anchors = sortBy(anchorMap, "offsetTop");
    return anchors;
  };

  const findActiveAnchor = (position) => {
    // recreate map b/c window can resize and
    // positions shift as images load etc
    const aMap = createAnchorMap();

    const anchor = aMap.find((a, idx) => {
      const next = aMap[idx + 1];

      const adjustedPosition = position;
      const offset = position + window.innerHeight;

      // if at bottom of page return the last
      if (offset >= document.documentElement.offsetHeight) {
        return idx === aMap.length - 1;
      }
      // if before first, return first
      else if (adjustedPosition < aMap[0].offsetTop) {
        return idx === 0;
      }
      // if inbetween return it
      else if (next) {
        return a.offsetTop <= adjustedPosition && adjustedPosition < next.offsetTop;
      }
      // otherwise return the last
      return idx === aMap.length - 1;
    });
    return anchor;
  };

  const setActiveAnchor = (position) => {
    $(".topic-list-nav li.active").removeClass("active").children("a").removeAttr("aria-current");

    const anchorHref = findActiveAnchor(position).selector;

    const anchor = $navAnchors.toArray().find((a) => a.getAttribute("href") === anchorHref);

    $(anchor).closest("li").addClass("active");
    $(anchor).attr('aria-current', 'true');
  };

  return {
    onScroll: setActiveAnchor
  };
}

export function scrollSidePanel() {
  const unitContentContainer = $(".unit-content-container");
  const unitHeading = $(".th-content-unit-heading")[0];
  const contextNav = document.getElementById("contextnav");
  const alert = document.querySelector("th-alert");
  const padding = 10;
  let alertHeight = 0;
  if (alert) {
    alertHeight = alert.offsetHeight;
  }
  if (!unitContentContainer[0] || !unitHeading) {
    return;
  }
  const unitHeadingHeight = unitHeading.offsetHeight;

  const setSidePanelContentHeight = () => {
    if (unitContentContainer) {
      const contextNavOffset = contextNav.offsetTop + contextNav.offsetHeight;
      unitContentContainer.css({
        height: `calc(100vh - ${unitHeadingHeight + padding + alertHeight}px - ${contextNavOffset}px)`
      });
    }
  }

  return {
    onScroll: setSidePanelContentHeight
  }
}

export function unitPageOnScroll() {
  const stickyNav = stickyTopicNav();
  const scrollSpy = scrollSpyTopicNav();
  const sticky = stickyBreadcrumb();
  const sidePanel = scrollSidePanel();

  const onScroll = () => {
    const currentPosition = window.pageYOffset || document.documentElement.scrollTop;

    try {
      if (sticky) {
        sticky.onScroll(currentPosition);
      }
      if (stickyNav) {
        stickyNav.onScroll(currentPosition);
      }
      if (scrollSpy) {
        scrollSpy.onScroll(currentPosition);
      }
      if (sidePanel) {
        sidePanel.onScroll();
      }
    } catch (e) {
      console.warn("topic nav error", e);
    }
  };

  return {
    onScroll
  };
}

export default function unitPage() {
  const init = () => {
    try {
      smoothTopicNav();
      // unitPageOnScroll().onScroll();
      const sidePanel = scrollSidePanel();

      if(sidePanel) {
        scrollSidePanel().onScroll();
      }
    } catch (e) {
      console.warn("could not initialize topic nav", e);
    }
  };

  return {
    init,
    onScroll: unitPageOnScroll().onScroll
  };
}

$(() => {
  const page = unitPage();
  page.init();

  $(window).on("scroll", page.onScroll);
  $(window).on("scrollend", page.onScroll);

  $(window).on("resize", page.onScroll);

  if (isDesktop()) {
    const unitContent = document.querySelector(".th-unit-content");
    if (unitContent) {
      unitContent.classList.add('desktop');
    }
  }
});
